import { type SetComplexImmerStateAction, type Tag } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const TagsContext = createContext<
  [Record<number, Tag>, SetComplexImmerStateAction<Record<number, Tag>>]
>([[], dummyFunction]);

export default TagsContext;
